<template>
<!-- verify email and sms -->
<div v-if="$parent.verifyOption === 'verify_email' || $parent.verifyOption === 'verify_sms'">
    <div v-if="$parent.message" class="form-group">
        <div class="alert alert-danger">
            <i class="fa fa-info-circle"></i> {{ $t($parent.message) }}
        </div>
    </div>
    <div class="form-group" >
        <div class="text-center mb-3">
            <h3>{{$t('Verification')}}</h3>
            <p class="text-muted">{{$t('Please input your verification code')}}</p>
        </div>
    </div>
    <div class="form-group form-group-feedback form-group-feedback-left" >
        <input type="text" class="form-control" :placeholder="$t('Verification Code')" @keyup.enter="$parent.handleRegister()" v-model="$parent.inputVerficationCode"/>
        <div class="form-control-feedback">
            <i class="fa-envelope fas text-muted"></i>
        </div>
    </div>
    
    <div v-if="$parent.verifyOption === 'verify_email'" class="form-group">
        <p class="m-0 text-muted">
            {{$t('Verification code was just sent to')}} 
            <b style="color:black;">{{ $parent.form.email }}</b>
        </p>
        <p class="m-0 text-muted">
            <b style="color:black;">({{$t('Ref No.')}}: <span id="ref_code">{{ $parent.refCodeId }}</span>) </b> {{ $t('_VerificationCode.You have') }} 
            <span class="text-center d-inline-block" style="min-width:21px">{{ $parent.countDown }}</span> 
            {{ $t('seconds to verify code.') }} 
            {{ $t("Didn't receive the verification code?") }} 
            <a href="javascript:void(0);" @click="$parent.sendMail()"><u>{{$t('Resend')}}</u></a>
        </p>
    </div>

    <div v-if="$parent.verifyOption === 'verify_sms'" class="form-group">
        <p class="m-0 text-muted">
            {{ $t('Verification code was just sent to') }} 
            <b class="ml-1" style="color:black;">
                <span style="font-weight: 500;font-size: 18px; margin-right:1px; letter-spacing: 0.10em;">
                    ··· ···
                </span> 
                {{ $parent.form.telephone.substr($parent.form.telephone.length - 4) }}
            </b>
        </p>
        <p class="m-0 text-muted">
            <b style="color:black;">({{$t('Ref No.')}}: <span id="ref_code">{{ $parent.refCodeId }}</span>) </b> {{ $t('_VerificationCode.You have') }} 
            <span class="text-center d-inline-block" style="min-width:21px">{{ $parent.countDown }}</span> 
            {{ $t('seconds to verify code.') }} 
            {{ $t("Didn't receive the verification code?") }} 
            <a href="javascript:void(0);" @click="$parent.sendSms()"><u>{{$t('Resend')}}</u></a>
        </p>
    </div>

    <div class="form-group">
        <ladda text="Verify and Sign In" :btnClass="'btn btn-primary btn-block'" :loading="$parent.loading" @click="$parent.handleRegister()"></ladda>
    </div>
    <div class="form-group">
        <button type="button" @click="backVerifyOption()" class="btn btn-light btn-block">{{$t('Back')}}</button>
    </div>
</div>
<!-- verify email and sms end -->
</template>

<script>

import Ladda from "@/plugins/Ladda.vue";

export default {
    components: {
        Ladda,
    },

    methods: {
       backVerifyOption() {
           this.$parent.alreadyCode = false;
           this.$parent.message = false;
       }
    },

};
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/VerificationCode.vue